import type { ConsumerProBillingInterval } from '../constants/consumerProBilling.constants'

/** Session-only hint so /packs can avoid a Hobby flash after SPA navigation (no PII). */
export const PRICING_STABLE_CONSUMER_SNAPSHOT_STORAGE_KEY = 'zporti_pricing_consumer_snapshot_v1'

export interface PersistedConsumerPricingSnapshot {
  consumerPlanTier: 'FREE' | 'PRO'
  consumerProBillingInterval: ConsumerProBillingInterval | null
  consumerCancelAtPeriodEnd: boolean
  consumerPeriodEndIso: string | null
}

function isSessionStorageAvailable(): boolean {
  return typeof sessionStorage !== 'undefined'
}

export function readPersistedConsumerPricingSnapshot(): PersistedConsumerPricingSnapshot | null {
  if (!isSessionStorageAvailable()) {
    return null
  }
  try {
    const raw = sessionStorage.getItem(PRICING_STABLE_CONSUMER_SNAPSHOT_STORAGE_KEY)
    if (raw == null || raw.length === 0) {
      return null
    }
    const parsed = JSON.parse(raw) as unknown
    if (typeof parsed !== 'object' || parsed === null) {
      return null
    }
    const o = parsed as Record<string, unknown>
    if (o.consumerPlanTier !== 'PRO' && o.consumerPlanTier !== 'FREE') {
      return null
    }
    const interval = o.consumerProBillingInterval
    const consumerProBillingInterval =
      interval === 'month' || interval === 'year' ? interval : null
    return {
      consumerPlanTier: o.consumerPlanTier === 'PRO' ? 'PRO' : 'FREE',
      consumerProBillingInterval,
      consumerCancelAtPeriodEnd: o.consumerCancelAtPeriodEnd === true,
      consumerPeriodEndIso: typeof o.consumerPeriodEndIso === 'string' ? o.consumerPeriodEndIso : null,
    }
  } catch {
    return null
  }
}

export function writePersistedConsumerPricingSnapshot(snapshot: PersistedConsumerPricingSnapshot): void {
  if (!isSessionStorageAvailable()) {
    return
  }
  try {
    sessionStorage.setItem(PRICING_STABLE_CONSUMER_SNAPSHOT_STORAGE_KEY, JSON.stringify(snapshot))
  } catch {
    /* quota / private mode */
  }
}

export function clearPersistedConsumerPricingSnapshot(): void {
  if (!isSessionStorageAvailable()) {
    return
  }
  try {
    sessionStorage.removeItem(PRICING_STABLE_CONSUMER_SNAPSHOT_STORAGE_KEY)
  } catch {
    /* noop */
  }
}
